import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Select from "react-select";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import paginationFactory from "react-bootstrap-table2-paginator";
import preloader from "../../../helpers/preloader";
import calculatePrice from "../../../helpers/calculate_price";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../helpers/units";
import EnterQuantityForPoModal from "../../../components/EnterQuantityForPoModal";
import UpdateQuantityForPoModal from "../../../components/UpdateQuantityForPoModal";
import AllDrafts from "../Draft/AllDrafts";

const SupplierWiseRequisition = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartModal, setCartModal] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  useEffect(() => {
    loadAllMainStores();
    loadDraftOrders();
  }, []);

  const [selectedItems, setSelectedItems] = useState([]);
  const [allStores, setAllStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [deliverAtStore, setDeliverAtStore] = useState(false);
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [editUnitModal, setEditUnitModal] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const loadAllMainStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result = [
        // { label: "None", value: "", _id: "" },
        ...response.data.filter((branch) => branch.type === "Main Store"),
        // ...response.data
      ];
      setSearchKey("")
      setAllStores(result);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [isLoadingDraft, setIsLoadingDraft] = useState(false);
  const [openDraftModal, setOpenDraftModal] = useState(false);
  const [draftOrders, setDraftOrders] = useState([]);
  const loadDraftOrders = async () => {
    let url = process.env.REACT_APP_BASEURL + "po_draft/get_draft";
    let response = await postSubmitForm(url, {type:"Main_Store_Wise"});
    if (response.status === 1) {
      setDraftOrders(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [suppliers, setSuppliers] = useState([])
  const loadSuupliers = async (category) => {
    let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
    let response = await postSubmitForm(url, { categories: [category.category] });
    if (response.status === 1) {
      const supplier = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      // const UpdatedWithSupplier = categorisezItem.map((item) =>
      //   item.category === e.category ? { ...item, suppliers: supplier } : item
      // );
       const updatedSuppliers = supplier.map((s) => ({
         value: s.value || s.name,
         name: s.name,
       }));
        setCategorisezItem((prevCategorisezItem) =>
          prevCategorisezItem.map((itm) =>
            itm.category === category.category
              ? {
                  ...itm,
                  suppliers: updatedSuppliers,
                  selSupp: itm.selSupp || category.selSupp,
                }
              : itm
          )
        );
      // setCategorisezItem(UpdatedWithSupplier);
      setSuppliers(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [searchkey, setSearchKey] = useState("");
  const [allItems, setAllItems] = useState([]);

  const loadItems = async (storeId = null) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "items/get_mainstorewise_for_po";
     const response = await postSubmitForm(url, {
       store_id:
         storeId === null ? selectedStore && selectedStore.value : storeId,
     });
    if (response && response.status === 1) {
      const updatedItems = response.data.map((item) => ({
        ...item,
        total_price: 0,
      }));
      const SortedData = updatedItems.sort((a, b) => a.name.localeCompare(b.name));
      preloader(false);
      setAllItems(SortedData);
      setFilteredItems(SortedData);
      setDisableSubmit(false);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    filterItems(allItems);
  }, [searchkey]);

  const filterItems = async (allItems) => {
    let filteredItems;
    if (!searchkey || searchkey.trim() === "") {
      filteredItems = allItems;
    } else {
      filteredItems = allItems?.filter((item) => {
        return (
          item.name.toLowerCase().includes(searchkey.toLowerCase()) ||
          item.category.toLowerCase().includes(searchkey.toLowerCase())
        );
      });
    }
    setFilteredItems(filteredItems);
  };

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "45%" };
      },
      editable: false,
    },
    {
      text: props.t("Cat."),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Sub-Cat."),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Brand"),
      dataField: "brand",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
  ];

  const handleDeleteRow = (itemId) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter(
        (item) => item.item_id !== itemId
      );
      return updatedCartItems;
    });
  };

  const columns_cartitems = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <span className="me-2">
                {formatUnitsForReport(row.quantity)}
              </span>
                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    setSelectedItems(row);
                    setSelectedRowsUnit(row.quantity);
                    setEditUnitModal(true);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },

    {
      text: props.t("Price"),
      dataField: "price",
      formatter: (cell, row) => {
        return row.price + " / " + row.unit_for_po;
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: false,
      formatter: (cell, row) => {
        return row.total_price ? Number(row.total_price).toFixed(2) :""
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData?.reduce((acc, item) => acc + item, 0);
        return total ? Number(total).toFixed(2) : "";
      },
    },
    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.item_id);
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const populateCartFromDraft = async (draftPO) => {
    setIsLoadingDraft(true);

    const branchDetails = {
      label: draftPO.branch_details.name,
      value: draftPO.branch_details._id,
      ...draftPO.branch_details,
    };

    const newCartCategorizesItems = draftPO.items.map((category) => ({
      category: category.category,
      selSupp: category.supplier, 
      items: category.items.map((item) => ({
        ...item,
        category: category.category,
      })),
      suppliers: [], 
    }));
    setSelectedStore(branchDetails);
     const isCentralStore = branchDetails.label === "CENTRAL STORE";
     await loadItems(isCentralStore ? "" : branchDetails.value);
setCartItems(newCartCategorizesItems.flatMap((category) => category.items));
setCategorisezItem(newCartCategorizesItems);   
 setDeliverAtStore(draftPO.deliver_at_branch);
    for (const category of newCartCategorizesItems) {
      await loadSuupliers(category);
    }
    setIsLoadingDraft(false);
  };

  const [selectedDraftID, setSelectedDraftID] = useState("");
  const handleDraftPOSelection = (row) => {
    // return
    setSelectedDraftID(row._id);
    populateCartFromDraft(row);
    setOpenDraftModal(false);
  };

  const handleStoreSelection = (selectedOption) => {
    setSelectedStore(selectedOption);
    setCartItems([]);
    setCategorisezItem([]);
    loadItems(selectedOption.value);
  };

  const selectDraftPORow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        handleDraftPOSelection(row);
      }
    },
    selected: [selectedDraftID],
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: "#ecf0a1",
    selected: cartItems.map((item) => item.item_id),
    nonSelectable: cartItems
      .filter((cartItem) =>
        filteredItems.some(
          (filterItem) => filterItem.item_id === cartItem.item_id
        )
      )
      .map((item) => item.item_id),
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        setSelectedItems(row);
        SelectDefaultUnit(row);
        updateSelectedItems(row, isSelect);
      } else {
        e.preventDefault();
      }
    },
  };
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);

  function SelectDefaultUnit(row) {
    setSelectedRowsUnit([
      {
        index: 0,
        unit: row.unit_levels[0].unit,
        formula: row.unit_levels[0].value,
        value: 0,
        isChecked: true,
      },
    ]);
    setSelectUnitModal(true);
  }

  function updateSelectedItems(row, isSelect) {
    setCartItems((prevSelected) => {
      if (isSelect) {
        if (!prevSelected.some((item) => item.item_id === row.item_id)) {
          return [...prevSelected, row];
        }
      } else {
        const isnoUnitsSelected = selectedRowsUnit.every(
          (unit) => !unit.isChecked
        );
        if (isnoUnitsSelected) {
          return prevSelected.filter((item) => item.item_id !== row.item_id);
        }
      }
      return prevSelected;
    });
  }

  const handleSubmitRequisition = async () => {
    let payload = categorisezItem.map((category) => ({
      category: category.category,
      supplier: category.selSupp.id,
      items: category.items.map((item) => ({
        item_id: item.item_id,
        name: item.name,
        category: item.category,
        sub_category: item.sub_category,
        brand: item.brand,
        unit_levels: item.unit_levels.map(({ unit, value }) => ({
          unit,
          value,
        })),
        unit_for_po: item.unit_for_po,
        quantity:
          item.quantity.map(({ unit, value }) => ({ unit, value })) || null,
        price: +item.price,
        total_price: +item.total_price,
      })),
    }));

    try {
      if (categorisezItem.some((category) => category.selSupp === "")) {
        showNotification("Please enter a valid quantity for at least one unit", "Warning");
        return;
      } else if (
        categorisezItem.some((category) =>
          category.items.some((item) =>
            item.quantity.length > 0 && item.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))
          )
        )
      ) {
        showNotification(
          "Please enter a valid quantity for each unit",
          "Warning"
        );
        return;
      }
      if (categorisezItem.length > 0) {
        setDisableSubmit(true)
        let url = process.env.REACT_APP_BASEURL + "purchaseorders/insert";
        let data_to_send = { items: payload };
        data_to_send.draft_id = selectedDraftID;
        if (selectedStore !== "") {
          data_to_send.branch_id = selectedStore && selectedStore._id;
        }
        data_to_send.deliver_at_mainstore = true;
        // console.log(data_to_send);
        let response = await postSubmitForm(url, data_to_send);
        if (response.status === 1) {
          setDisableSubmit(false);
          setSelectedDraftID("");
          loadDraftOrders();
          showNotification(response.message, "Success");
          setCartItems([]);
          setCategorisezItem([]);
          setCartModal(!cartModal);
          setSelectedItems([]);
          setSelectedStore("");
          setSelectedRowsUnit([]);
            for (let i = 0; i < response.data.length; i++) {
              window.open(
                `/purchase_order?po_id=${response.data[i]}`,
                "_blank"
              );
            }
          
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          setDisableSubmit(false)
          showNotification(response.message, "Error");
        }
      } else {
        setDisableSubmit(false)
        showNotification(
          "Please select at least one item and supplier.",
          "Error"
        );
      }
    } catch (error) {
      setDisableSubmit(false)
      showNotification(error.message, "Error");
    }
  };

  const [isLoading , setIsLoading] = useState(false)
  const handleSubmitDraft = async () => {
 let payload = categorisezItem.map((category) => ({
   category: category.category,
   supplier: category.selSupp,
   items: category.items.map((item) => ({
     item_id: item.item_id,
     name: item.name,
     category: item.category,
     sub_category: item.sub_category,
     brand: item.brand,
     unit_levels: item.unit_levels,
     unit_for_po: item.unit_for_po,
     quantity:item.quantity,
     price: +item.price,
     total_price: +item.total_price,
   })),
 }));    // console.log(payload);
    //  return

    try {
      setIsLoading(true)
    if (
        categorisezItem.some((category) =>
          category.items.some((item) =>
            item.quantity.length > 0 && item.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))
          )
        )
      ) {
        showNotification("Please enter a valid quantity for at least one unit", "Warning");
        return;
      }
      if (categorisezItem.length > 0) {
        let url = process.env.REACT_APP_BASEURL + "po_draft/save_draft";
        let data_to_send = { items: payload };
        data_to_send.draft_id = selectedDraftID;
        data_to_send.type = "Main_Store_Wise";
        if (selectedStore !== "") {
          data_to_send.branch_id = selectedStore && selectedStore._id;
        }
        data_to_send.deliver_at_mainstore = true;
        // console.log(data_to_send);
        let response = await postSubmitForm(url, data_to_send);
        if (response.status === 1) {
          setSelectedDraftID("");
          loadDraftOrders();
          showNotification(response.message, "Success");
          setCartItems([]);
          setCategorisezItem([]);
          setDeliverAtStore(false)
          setCartModal(!cartModal);
          setSelectedItems([]);
          setSelectedStore("");
          setSelectedRowsUnit([]);      
        } else {
          setDisableSubmit(false)
          showNotification(response.message, "Error");
        }
      } else {
        showNotification(
          "Please select at least one item and supplier.",
          "Error"
        );
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const handleAddUnits = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels) 
    const updatedCartItems = cartItems.map((item) => {
      if (item.item_id === selectedItems.item_id) {
        const total_price = calculatePrice(
          selectedItems.unit_levels,
          convertedQuantity,
          item.price,
          item.unit_for_po
        );
        return { ...item, quantity: convertedQuantity, total_price };
      } else {
        return item;
      }
    });

    setCartItems(updatedCartItems);
    setSelectUnitModal(false);
    setSelectedItems([]);
    setSelectedRowsUnit([]);
  };

  const [categorisezItem, setCategorisezItem] = useState([]);

  // function groupBy(array, property) {
  //   return Object.values(
  //     array.reduce((acc, obj) => {
  //       const key = obj[property];
  //       if (!acc[key]) {
  //         acc[key] = { category: key, items: [], suppliers: [], selSupp: "" };
  //       }
  //       acc[key].items.push(obj);
  //       return acc;
  //     }, {})
  //   );
  // }
  function groupBy(array, property) {
    return Object.values(
      array.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = {category: key,items: [],
            suppliers: obj.suppliers || [],
            selSupp: obj.selSupp || "",
          };
        }
        acc[key].items.push(obj);
        return acc;
      }, {})
    );
  }

  useEffect(() => {
    setCategorisezItem((prevCategorizedItems) => {
      const newCategorizedItems = groupBy(cartItems, "category");

      return Object.values(newCategorizedItems).map((category) => {
        const existingCategory = prevCategorizedItems.find(
          (c) => c.category === category.category
        );
        return {
          ...category,
          suppliers: existingCategory ? existingCategory.suppliers : [],
          selSupp: existingCategory ? existingCategory.selSupp : "",
        };
      });
    });
  }, [cartItems]);

  function handleCloseModal() {
    const hasValidquantity =
      selectedItems?.quantity &&
      selectedItems.quantity.every((unit) => unit.value > 0);
    if (!hasValidquantity) {
      setCartItems((prevCartItems) =>
        prevCartItems.filter((item) => item.item_id !== selectedItems.item_id)
      );
    }
    setSelectUnitModal(false);
  }

  // const handlePriceChange = (e) => {
  //   const isItemInCart = cartItems.some(
  //     (item) => item.item_id === selectedItems.item_id
  //   );
  //   if (isItemInCart) {
  //     const updatedCartItems = cartItems.map((item) =>
  //       item.item_id === selectedItems.item_id
  //         ? { ...item, price: +e.target.value }
  //         : item
  //     );
  //     setCartItems(updatedCartItems);
  //   }
  // };

  const handleSupplierSelection = (e, item) => {
    const selectedSupplier = item.suppliers.find(
      (supplier) => supplier.value === e.target.value
    );
   setCategorisezItem((prevCategorisezItem) =>
     prevCategorisezItem.map((itm) =>
       itm.category === item.category
         ? {
             ...itm,
             selSupp: {
               id: selectedSupplier.value,
               name: selectedSupplier.name,
             },
           }
         : itm
     )
   );
  };

  const handleUpdateUnit = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels) 
    const isItemInCart = cartItems.some(
      (item) => item.item_id === selectedItems.item_id
    );
    if (isItemInCart) {
      const updatedCartItems = cartItems.map((item) =>
        item.item_id === selectedItems.item_id
          ? {
              ...item,
              quantity: convertedQuantity,
              total_price: calculatePrice(
                item.unit_levels,
                convertedQuantity,
                item.price,
                item.unit_for_po
              ),
            }
          : item
      );
      setCartItems(updatedCartItems);
      setEditUnitModal(false);
    } else {
      const newItem = {
        ...selectedItems,
        convertedQuantity: convertedQuantity,
        total_price: calculatePrice(
          selectedItems.unit_levels,
          convertedQuantity,
          selectedItems.price,
          selectedItems.unit_for_po
        ),
      };
      setCartItems((prevCartItems) => [...prevCartItems, newItem]);
      setEditUnitModal(false);
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Main Store-wise Purchase Order")}
            title={props.t("Procurement")}
            breadcrumbItem1={props.t("Main Store-wise Purchase Order")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody style={{ height: "120px" }}>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <AvField
                          name="search"
                          label={props.t("Search")}
                          placeholder={props.t("Search items here")}
                          type="text"
                          onChange={(e) => {
                            e.preventDefault();
                            setSearchKey(e.target.value);
                          }}
                        ></AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
            <Col lg={6}>
              <Card>
                <CardBody style={{ height: "120px" }}>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <Label>{props.t(" Main Store")}</Label>
                        <Select
                          options={allStores}
                          placeholder={props.t("None")}
                          onChange={handleStoreSelection}
                          value={selectedStore}
                          className="basic-single"
                          classNamePrefix="select"
                        />
                      </Col>

                      {/* {selectedStore && selectedStore.label !== "None" && (
                        <Col lg={12} className="mt-2">
                          <AvField
                            type="checkbox"
                            name="avFieldCheckbox"
                            onChange={(e) => {
                              setDeliverAtStore(!deliverAtStore);
                            }}
                            checked={deliverAtStore}
                            label="Deliver at Store."
                          />
                        </Col>
                      )} */}
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {filteredItems?.length<=0 ? (
                    <Row>
                    <Col md={6} lg={6} className="text-right">
                      <div>
                        <Button
                          type="submit"
                          color="success"
                          className="mb-2"
                          onClick={() => setOpenDraftModal(true)}
                        >
                          {props.t("View Draft PO")}
                        </Button>
                      </div>
                    </Col>
                    <Col
                      md={6}
                      lg={6}
                      className="d-flex justify-content-start text-align-start"
                    >
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mb-2"
                          onClick={() =>
                            setCartModal(!cartModal)
                          }
                        >
                          {props.t("View Cart")}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  ):(
<Row>
                    <Col md={2} lg={2} className="text-start">
                      <div>
                        <Button
                          type="submit"
                          color="success"
                          className="mb-2"
                          onClick={() => setOpenDraftModal(true)}
                        >
                          {props.t("View Draft PO")}
                        </Button>
                      </div>
                    </Col>
                    <Col md={8} lg={8}></Col>
                    <Col
                      md={2}
                      lg={2}
                      className="d-flex justify-content-end text-align-end"
                    >
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mb-2"
                          onClick={() =>
                            setCartModal(!cartModal)
                          }
                        >
                          {props.t("View Cart")}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  )}

                {filteredItems?.length>0 && (
                    <ToolkitProvider
                    bootstrap4
                    keyField="item_id"
                    data={filteredItems}
                    columns={columns_items}
                    noDataIndication={props.t("No data to display.")}
                    search
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          // pagination={paginationFactory(pagination_options)}
                          striped
                          hover
                          condensed
                          selectRow={selectRow}
                          {...props.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Cart Modal start  */}
          <Modal
            size="lg"
            isOpen={cartModal}
            toggle={() => setCartModal(!cartModal)}
          >
            <ModalHeader
              toggle={() => setCartModal(!cartModal)}
            >
              {props.t("Review Order Details")}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          {categorisezItem &&
                            categorisezItem.map((item) => {
                              if (item.items.length > 0) {
                                return (
                                  <>
                                    <Row>
                                      <Col lg={8}>
                                        <Label>
                                          {props.t("Category")}: {item.category}
                                        </Label>
                                      </Col>
                                      <Col lg={4}>
                                        <AvForm>
                                          <AvField
                                            name="supplier"
                                            type="select"
                                            value={
                                              item.selSupp
                                                ? typeof item.selSupp ===
                                                  "object"
                                                  ? item.selSupp.id ||
                                                    item.selSupp.name
                                                  : item.selSupp
                                                : ""
                                            }
                                            onClick={() => loadSuupliers(item)}
                                            onChange={(e) =>
                                              handleSupplierSelection(e, item)
                                            }
                                          >
                                            <option value="">
                                              {props.t("--Select Supplier--")}
                                            </option>
                                            {item.suppliers &&
                                              item.suppliers.map((e) => (
                                                <option
                                                  key={e.value || e.name}
                                                  value={e.value || e.name}
                                                >
                                                  {e.name}
                                                </option>
                                              ))}
                                          </AvField>
                                        </AvForm>

                                        {/* <Select
                                  options={item.suppliers}
                                  value={item.selSupp||""}
                                  onMenuOpen={()=>loadSuupliers(item)}
                                  onChange={(e)=>handleSupplierSelection(e,item)}
                                  closeMenuOnSelect={true}
                                  classNamePrefix="select"
                                  // isMulti={selectMore}
                                  // menuisOpen={true}
                                  required
                                  // className="basic-multi-select"
                                /> */}
                                      </Col>
                                    </Row>
                                    <ToolkitProvider
                                      bootstrap4
                                      keyField="item_id"
                                      data={item.items}
                                      columns={columns_cartitems}
                                      noDataIndication={props.t(
                                        "No data to display."
                                      )}
                                      search
                                    >
                                      {(props) => (
                                        <div>
                                          <BootstrapTable
                                            striped
                                            hover
                                            condensed
                                            cellEdit={cellEditFactory({
                                              mode: "click",
                                              blurToSave: true,
                                              afterSaveCell: (
                                                oldValue,
                                                newValue,
                                                row,
                                                column
                                              ) => {
                                                // console.log(row.price, row.quantity);
                                              },
                                            })}
                                            {...props.baseProps}
                                          />
                                        </div>
                                      )}
                                    </ToolkitProvider>
                                  </>
                                );
                              }
                            })}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <FormGroup className="mb-0 text-center">
                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            style={{width:"110px"}}
                            className="mr-2"
                            disabled={categorisezItem?.length <= 0 || disableSubmit || isLoading}
                            onClick={() => handleSubmitRequisition()}
                          >
                          {disableSubmit ? <Spinner size="sm" /> : props.t("Generate")} 
                          </Button>
                          <Button
                            type="submit"
                            style={{width:"140px"}}
                            disabled={categorisezItem?.length <= 0 || disableSubmit || isLoading} 
                            onClick={() => handleSubmitDraft()}
                          >
                            {isLoading ? <Spinner size={"sm"}/> :props.t("Save as Draft")}
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
          {/* Cart Modal End  */}

          {/* Draft Modal start  */}
           <AllDrafts
            isOpen={openDraftModal}
            toggle={() => setOpenDraftModal(!openDraftModal)}
            title={props.t("All Draft Purchase Orders")}
            data={draftOrders}
            keyField="_id"
            selectRow={selectDraftPORow}
            noDataMessage={props.t("No data to display.")}
            onDelete={()=>loadDraftOrders()}
            showSupplierColumn={false}
            storeType="Main Store"

          />
          {/* Draft Modal end  */}

          {/* Add Quantity modal  start */}
              <EnterQuantityForPoModal 
                    isOpen={selectUnitModal}
                    toggle={handleCloseModal}
                    onSubmit={handleAddUnits}
                    item={selectedItems}
                    selectedUnits={selectedRowsUnit}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    selectedItems={selectedItems}
                    />
          {/* Add Quantity modal end */}

          {/* Edit Quantity Modal start  */}
            <UpdateQuantityForPoModal
                    isOpen={editUnitModal}
                    toggle={()=>setEditUnitModal(false)}
                    onSubmit={handleUpdateUnit}
                    item={selectedItems}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    selectedItems={selectedItems}
                    />
          {/* Edit Quantity Modal end  */}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(SupplierWiseRequisition))
);
